import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Icon, Tooltip } from '@dixa/lib-shared-habla';
import { getMessageWithColor } from './getMessageWithColor';
/** Display the Messenger authentication level for the conversation. */
export const MessengerAuthenticationLevel = ({ isVerifiedUser, }) => {
    const { message, color } = getMessageWithColor(isVerifiedUser);
    return (_jsx(Box, Object.assign({ margin: "200 0 0 100" }, { children: _jsx(Tooltip, Object.assign({ dark: true, wrap: "div", content: message }, { children: _jsx(Icon, { name: "shield-alert", color: color }) })) })));
};
